import React from 'react';
interface TestimonialProps {
  quote: string;
  author?: string;
  profileImage?: string;
}
export const Testimonial = ({
  quote,
  author,
  profileImage
}: TestimonialProps) => {
  return <div className="bg-gray-50 p-3 sm:p-4 rounded-lg border-l-4 border-pink-400" data-id="element-278">
      <div className="flex items-start gap-3" data-id="element-279">
        {profileImage && <div className="flex-shrink-0" data-id="element-280">
            <img src={profileImage} alt="Profile" className="w-12 h-12 rounded-full object-cover border-2 border-pink-200" data-id="element-281" />
          </div>}
        <div className="flex-1" data-id="element-282">
          <p className="italic mb-2 text-sm sm:text-base" data-id="element-283">{quote}</p>
          {author && <p className="font-semibold text-xs sm:text-sm" data-id="element-284">— {author}</p>}
        </div>
      </div>
    </div>;
};